import React from 'react';
import {FieldArray, ErrorMessage, FastField} from 'formik';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../../../res/translations/messages';
import GeneratorClassifierChoiceType from '../GeneratorClassifierChoiceType';
import CommonFields from './CommonFields';
import Error from '../../../Error';
import FormRow from '../FormRow';
import {stripHtml} from '../../../../utils/text';

const INPUT_VALUES = [
    constants.EDITOR_TEMPLATES.NUMBER_1,
    constants.EDITOR_TEMPLATES.NUMBER_2,
];

const getItemDescription = (item) => {
    let description = item.title || item.text;
    if (description) {
        description = stripHtml(description);
    }
    return description ? `${item.id} - ${description}` : item.id;
};

class GeneratorClassifierType extends React.PureComponent {
    render() {
        const {name, form, previousPages} = this.props;

        const items = get(form.values, 'editor.pages', [])
            .flatMap(({items}, i) => items)
            .filter(({type}) => INPUT_VALUES.includes(type));

        return (
            <>
                <CommonFields name={name} form={form} previousPages={previousPages} />
                <FormRow name={`${name}.source`} label={messages.surveys.form.label.source}>
                    <FastField id={`${name}.source`} name={`${name}.source`} component="select"
                        className={classNames('form-control custom-select',
                            {error: get(form.errors, `${name}.source`) && get(form.touched, `${name}.source`)})}>
                        <option value="" disabled />
                        {items.map((item) => <option key={item.id} value={item.id}>{getItemDescription(item)}</option>)}
                    </FastField>
                    <ErrorMessage name={`${name}.source`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.classifierThresholds} />
                    </h4>
                    <FieldArray name={`${name}.choices`} component={GeneratorClassifierChoiceType} />
                    <ErrorMessage name={`${name}.choices`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>
            </>
        );
    }
}

export default GeneratorClassifierType;
